<template>
    <div class="mr-side-menu__wrapper hide cp-fixed">
        <div class="mr-side-menu__scroll-wrapper">
            <div class="mr-side-menu-top__wrapper">
                <div class="mr-logo__wrapper">
                    <img
                        src="@/assets/images/minilogo.svg"
                        alt="АльфаМед"
                        class="mr-logo-mini mr-logo-img"
                        width="52"
                        height="54"
                    >
                </div>

                <nav class="mr-side-menu-list__wrapper">
                    <slot v-for="(menuItem, index) in menuItems">
                        <router-link
                            v-if="menuItem.isActive === true"
                            :key="index"
                            :to="{ name: menuItem.path }"
                            class="mr-side-menu-item__wrapper"
                            :class="{ 'router-link-exact-active': currentRoot.indexOf(menuItem.code) !== -1 }"
                        >
                            <div
                                v-if="menuItem.hint.length > 0"
                                class="mr-side-menu-item__hint"
                                :class="menuItem.hintClass"
                            >
                                {{ menuItem.hint }}
                            </div>

                            <span class="mr-nav-icons__wrapper">
                                <icon-menu
                                    :class="index"
                                    class="mr-nav-icons"
                                    :size="menuItem.iconSize"
                                    :icon="menuItem.class"
                                />
                            </span>

                            <span class="mr-side-menu-item">{{ menuItem.name }}</span>
                        </router-link>
                    </slot>
                </nav>

                <div class="mr-side-menu-bottom">
                    <notifications />
                    
                    <div class="cp-user-info__wrapper">
                        <div class="cp-user-info">
                            <div class="cp-user-info--icon">
                                <div class="cp-user-info--icon__wrapper">
                                    <icon-font icon="user" size="19" />

                                    <span class="cp-user-name__wrapper cp-side-menu--hide">
                                        <span class="cp-user-name">{{ login }}</span>
                                        <span>{{ roleTitle }}</span>
                                    </span>

                                    <div class="cp-user-logout cp-side-menu--hide" @click="logOut">
                                        <icon-font class="" icon="logout" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import IconMenu from '@/components/icons/IconMenu.vue';
import IconFont from '@/components/icons/IconFont.vue';
import Notifications from '@/components/notificationMenu/Notification.vue';

import AuthModule from '@/store/auth';

export default {
    name: 'SideMenu',
    components: { IconFont, IconMenu, Notifications },
    props: {
        menuItems: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isShow: true,
        };
    },
    computed: {
        ...mapState('user', ['login', 'roleTitle']),
        currentRoot() {
            const paths = this.$route.path.split('/');

            return paths[1];
        },
    },
    methods: {
        async logOut() {
            await AuthModule.logoutRequest();
            this.$router.push({ name: 'login' });
        },
    },
};
</script>
